import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BooleanRendererComponent } from './boolean-renderer.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    BooleanRendererComponent
  ],
  exports: [
    BooleanRendererComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class BooleanRendererModule { }
